import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=4bfb663f&scoped=true"
import script from "./adminLayout.vue?vue&type=script&lang=js"
export * from "./adminLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb663f",
  null
  
)

export default component.exports